// src/components/HomePage.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css'; // Import the CSS file
import BoekTaxi from './BoekTaxi'; // Import the BoekTaxi component

function HomePage() {
  const [currentImage, setCurrentImage] = useState(0);
  const images = ['/car1.jpg', '/car2.jpg', '/car3.jpg', '/car4.jpg'];
  const imageCount = images.length;

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImage((prevImage) => (prevImage + 1) % imageCount);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(intervalId); // Clean up the interval on unmount
  }, [imageCount]);

  return (
    <div className="home-page">
      <div className="content-wrapper"> {/* Add this wrapper */}
        <img src="/logo_ORG.png" alt="logo" className="half-size-image" />
        <h1>Welcome bij Hofman Transfer Services</h1>
        <p>
          Taxi nodig vanuit regio Amsterdam?
        </p>
        <p>Welkom bij uw betrouwbare taxi-service!</p>
        <p>
          Of u nu reist voor werk, een dagje uit of een luchthavenrit – wij
                  brengen u snel en comfortabel naar elke locatie in Benelux en Duitsland.
         </p>
         <p> Bij ons
          weet u altijd waar u aan toe bent dankzij een duidelijke vaste
          prijsafspraak zonder verrassingen achteraf.
        </p>
        <p>
          Reserveer direct of neem contact met ons op via 020-7370833.
        </p>

        <img src="/car1.jpg" alt="Car 1" className="half-size-image" />
      </div> {/* Close the wrapper */}

      {/*<div className="carousel-container">*/}
      {/*  <div className="carousel" style={{ transform: `translateX(-${currentImage * 1000}px)` }}>*/}
      {/*    {images.map((image, index) => (*/}
      {/*      <img key={index} src={image} alt={`Car ${index + 1}`} />*/}
      {/*    ))}*/}
      {/*  </div>*/}
      {/* </div>*/}

      {/* <BoekTaxi /> */}{/* Render the BoekTaxi component */}
    </div>
  );
}

export default HomePage;
